<mat-toolbar class="custom-header">
  <span (click)="guiService.goTo('main/user-nutrition')">
    <mat-icon svgIcon="mat:arrow_back"></mat-icon>
  </span>
</mat-toolbar>
<div class="container" *ngIf="guiService.userLogged">
  <div class="page-title">
    <h2>{{"PROFILE.NUTRITION.MEAL-PLAN" | translate}}</h2>
    <div>
      <span (click)="openModalMealInfo(diet.dishComposeInfos)" class="icon-dish-compose">
        <mat-icon svgIcon="mat:restaurant"></mat-icon>
      </span>
      <span class="help-circle" (click)="openModalSupport()" class="icon-support">
        <mat-icon svgIcon="mat:help"></mat-icon>
      </span>
    </div>
  </div>
  <div class="tabs">
    <span class="tab" [class.active-tab]="activeTab ==='Meals'" (click)="selectTab('Meals')">{{"PROFILE.NUTRITION.MEALS"
      | translate}}</span>
    <span class="tab" [class.active-tab]="activeTab ==='Infos'" (click)="selectTab('Infos')">Infos</span>
  </div>
  <div *ngIf="activeTab ==='Meals'">
    <div class="info-box read-care" (click)="openModalDisclaimer()">
      <p class="data-label red">{{"PROFILE.NUTRITION.READ-CAREFULLY" | translate}}</p>
      <p class="data">
        <mat-icon svgIcon="mat:arrow_forward_ios"></mat-icon>
      </p>
    </div>
    <div>
      <h3>{{"PROFILE.NUTRITION.MONDAY" | translate}}</h3>
      <swiper-container *ngIf="diet" [slidesPerView]="1.5" class="recipes-swiper">
        <swiper-slide *ngFor="let recipe of recipes.monday">
          <div class="slide slide-tutorial-meal" (click)="openModalRecipeInfo(recipe)">
            <p>{{"PROFILE.NUTRITION."+recipe.category | translate}}</p>
            <div class="recipe-image"
              [ngStyle]="{ 'background-image': 'url(' + environmentNode+'/get-recipe-image/'+recipe._id + ')' }"></div>
            <p>{{recipe.i18nTitle[translate.currentLang.toUpperCase()]}}</p>
          </div>
        </swiper-slide>
      </swiper-container>
      <swiper-container *ngIf="!diet" [slidesPerView]="1.5">
        <swiper-slide *ngFor="let recipe of recipePlaceholder">
          <div class="slide">
            <div class="recipe-image">
              <ion-skeleton-text style="width: 100%;" [animated]="true"></ion-skeleton-text>
            </div>
          </div>
        </swiper-slide>
      </swiper-container>
    </div>
    <div>
      <h3>{{"PROFILE.NUTRITION.TUESDAY" | translate}}</h3>
      <swiper-container *ngIf="diet" [slidesPerView]="1.5">
        <swiper-slide *ngFor="let recipe of recipes.tuesday">
          <div class="slide" (click)="openModalRecipeInfo(recipe)">
            <p>{{"PROFILE.NUTRITION."+recipe.category | translate}}</p>
            <div class="recipe-image"
              [ngStyle]="{ 'background-image': 'url(' + environmentNode+'/get-recipe-image/'+recipe._id + ')' }"></div>
            <p>{{recipe.i18nTitle[translate.currentLang.toUpperCase()]}}</p>
          </div>
        </swiper-slide>
      </swiper-container>
      <swiper-container *ngIf="!diet" [slidesPerView]="1.5">
        <swiper-slide *ngFor="let recipe of recipePlaceholder">
          <div class="slide">
            <div class="recipe-image">
              <ion-skeleton-text style="width: 100%;" [animated]="true"></ion-skeleton-text>
            </div>
          </div>
        </swiper-slide>
      </swiper-container>
    </div>
    <div>
      <h3>{{"PROFILE.NUTRITION.WEDNESDAY" | translate}}</h3>
      <swiper-container *ngIf="diet" [slidesPerView]="1.5">
        <swiper-slide *ngFor="let recipe of recipes.wednesday">
          <div class="slide" (click)="openModalRecipeInfo(recipe)">
            <p>{{"PROFILE.NUTRITION."+recipe.category | translate}}</p>
            <div class="recipe-image"
              [ngStyle]="{ 'background-image': 'url(' + environmentNode+'/get-recipe-image/'+recipe._id + ')' }"></div>
            <p>{{recipe.i18nTitle[translate.currentLang.toUpperCase()]}}</p>
          </div>
        </swiper-slide>
      </swiper-container>
      <swiper-container *ngIf="!diet" [slidesPerView]="1.5">
        <swiper-slide *ngFor="let recipe of recipePlaceholder">
          <div class="slide">
            <div class="recipe-image">
              <ion-skeleton-text style="width: 100%;" [animated]="true"></ion-skeleton-text>
            </div>
          </div>
        </swiper-slide>
      </swiper-container>
    </div>
    <div>
      <h3>{{"PROFILE.NUTRITION.THURSDAY" | translate}}</h3>
      <swiper-container *ngIf="diet" [slidesPerView]="1.5">
        <swiper-slide *ngFor="let recipe of recipes.thursday">
          <div class="slide" (click)="openModalRecipeInfo(recipe)">
            <p>{{"PROFILE.NUTRITION."+recipe.category | translate}}</p>
            <div class="recipe-image"
              [ngStyle]="{ 'background-image': 'url(' + environmentNode+'/get-recipe-image/'+recipe._id + ')' }"></div>
            <p>{{recipe.i18nTitle[translate.currentLang.toUpperCase()]}}</p>
          </div>
        </swiper-slide>
      </swiper-container>
      <swiper-container *ngIf="!diet" [slidesPerView]="1.5">
        <swiper-slide *ngFor="let recipe of recipePlaceholder">
          <div class="slide">
            <div class="recipe-image">
              <ion-skeleton-text style="width: 100%;" [animated]="true"></ion-skeleton-text>
            </div>
          </div>
        </swiper-slide>
      </swiper-container>
    </div>

    <div>
      <h3>{{"PROFILE.NUTRITION.FRIDAY" | translate}}</h3>
      <swiper-container *ngIf="diet" [slidesPerView]="1.5">
        <swiper-slide *ngFor="let recipe of recipes.friday">
          <div class="slide" (click)="openModalRecipeInfo(recipe)">
            <p>{{"PROFILE.NUTRITION."+recipe.category | translate}}</p>
            <div class="recipe-image"
              [ngStyle]="{ 'background-image': 'url(' + environmentNode+'/get-recipe-image/'+recipe._id + ')' }"></div>
            <p>{{recipe.i18nTitle[translate.currentLang.toUpperCase()]}}</p>
          </div>
        </swiper-slide>
      </swiper-container>
      <swiper-container *ngIf="!diet" [slidesPerView]="1.5">
        <swiper-slide *ngFor="let recipe of recipePlaceholder">
          <div class="slide">
            <div class="recipe-image">
              <ion-skeleton-text style="width: 100%;" [animated]="true"></ion-skeleton-text>
            </div>
          </div>
        </swiper-slide>
      </swiper-container>
    </div>

    <div>
      <h3>{{"PROFILE.NUTRITION.SATURDAY" | translate}}</h3>
      <swiper-container *ngIf="diet" [slidesPerView]="1.5">
        <swiper-slide *ngFor="let recipe of recipes.saturday">
          <div class="slide" (click)="openModalRecipeInfo(recipe)">
            <p>{{"PROFILE.NUTRITION."+recipe.category | translate}}</p>
            <div class="recipe-image"
              [ngStyle]="{ 'background-image': 'url(' + environmentNode+'/get-recipe-image/'+recipe._id + ')' }"></div>
            <p>{{recipe.i18nTitle[translate.currentLang.toUpperCase()]}}</p>
          </div>
        </swiper-slide>
      </swiper-container>
      <swiper-container *ngIf="!diet" [slidesPerView]="1.5">
        <swiper-slide *ngFor="let recipe of recipePlaceholder">
          <div class="slide">
            <div class="recipe-image">
              <ion-skeleton-text style="width: 100%;" [animated]="true"></ion-skeleton-text>
            </div>
          </div>
        </swiper-slide>
      </swiper-container>
    </div>

    <div>
      <h3>{{"PROFILE.NUTRITION.SUNDAY" | translate}}</h3>
      <swiper-container *ngIf="diet" [slidesPerView]="1.5">
        <swiper-slide *ngFor="let recipe of recipes.sunday">
          <div class="slide" (click)="openModalRecipeInfo(recipe)">
            <p>{{"PROFILE.NUTRITION."+recipe.category | translate}}</p>
            <div class="recipe-image"
              [ngStyle]="{ 'background-image': 'url(' + environmentNode+'/get-recipe-image/'+recipe._id + ')' }"></div>
            <p>{{recipe.i18nTitle[translate.currentLang.toUpperCase()]}}</p>
          </div>
        </swiper-slide>
      </swiper-container>
      <swiper-container *ngIf="!diet" [slidesPerView]="1.5">
        <swiper-slide *ngFor="let recipe of recipePlaceholder">
          <div class="slide">
            <div class="recipe-image">
              <ion-skeleton-text style="width: 100%;" [animated]="true"></ion-skeleton-text>
            </div>
          </div>
        </swiper-slide>
      </swiper-container>
    </div>
  </div>
  <div *ngIf="activeTab === 'Infos'">
    <div class="nutritionist-container" *ngIf="nutritionists[diet.nutriEmail]">
      <div class="nutritionist-infos">
        <div class="thumb-img" [ngStyle]="{'background-image': 'url(assets/img/'+nutritionists[diet.nutriEmail].img+')'}">
        </div>
        <span>
          <p>{{nutritionists[diet.nutriEmail].fullName}}</p>
          <p class="job-title">{{nutritionists[diet.nutriEmail].jobTitle}}</p>
          <p class="instagram">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M320.3 205C256.8 204.8 205.2 256.2 205 319.7C204.8 383.2 256.2 434.8 319.7 435C383.2 435.2 434.8 383.8 435 320.3C435.2 256.8 383.8 205.2 320.3 205zM319.7 245.4C360.9 245.2 394.4 278.5 394.6 319.7C394.8 360.9 361.5 394.4 320.3 394.6C279.1 394.8 245.6 361.5 245.4 320.3C245.2 279.1 278.5 245.6 319.7 245.4zM413.1 200.3C413.1 185.5 425.1 173.5 439.9 173.5C454.7 173.5 466.7 185.5 466.7 200.3C466.7 215.1 454.7 227.1 439.9 227.1C425.1 227.1 413.1 215.1 413.1 200.3zM542.8 227.5C541.1 191.6 532.9 159.8 506.6 133.6C480.4 107.4 448.6 99.2 412.7 97.4C375.7 95.3 264.8 95.3 227.8 97.4C192 99.1 160.2 107.3 133.9 133.5C107.6 159.7 99.5 191.5 97.7 227.4C95.6 264.4 95.6 375.3 97.7 412.3C99.4 448.2 107.6 480 133.9 506.2C160.2 532.4 191.9 540.6 227.8 542.4C264.8 544.5 375.7 544.5 412.7 542.4C448.6 540.7 480.4 532.5 506.6 506.2C532.8 480 541 448.2 542.8 412.3C544.9 375.3 544.9 264.5 542.8 227.5zM495 452C487.2 471.6 472.1 486.7 452.4 494.6C422.9 506.3 352.9 503.6 320.3 503.6C287.7 503.6 217.6 506.2 188.2 494.6C168.6 486.8 153.5 471.7 145.6 452C133.9 422.5 136.6 352.5 136.6 319.9C136.6 287.3 134 217.2 145.6 187.8C153.4 168.2 168.5 153.1 188.2 145.2C217.7 133.5 287.7 136.2 320.3 136.2C352.9 136.2 423 133.6 452.4 145.2C472 153 487.1 168.1 495 187.8C506.7 217.3 504 287.3 504 319.9C504 352.5 506.7 422.6 495 452z"/></svg>            {{nutritionists[diet.nutriEmail].instagram}}
          </p>
        </span>
      </div>

      <!-- Nota separata -->
      <p class="note" *ngIf="diet?.infos?.note && diet.infos.note !== ''">
        {{diet.infos.note}}
      </p>
    </div>
    <span class="nutri-goal">
      <h3>{{"PROFILE.NUTRITION.MEAL-PLAN-INFOS.NUTRITITIONAL_GOAL" | translate}}</h3>
      <div class="info-box">
        <p class="data-label">{{"PROFILE.NUTRITION.MEAL-PLAN-INFOS.DAILY_KCAL" | translate}}</p>
        <p class="data">{{diet.infos.dailyKcal}}</p>
      </div>
    </span>
    <span class="composi">
      <h3>{{"PROFILE.NUTRITION.MEAL-PLAN-INFOS.COMPOSITION" | translate}}</h3>
      <div class="info-box">
        <p class="data-label">{{"PROFILE.NUTRITION.MEAL-PLAN-INFOS.CARBOHYDRATES" | translate}}</p>
        <p class="data">{{diet.infos.carbohydrates}}</p>
      </div>
      <div class="info-box">
        <p class="data-label">{{"PROFILE.NUTRITION.MEAL-PLAN-INFOS.FATS" | translate}}</p>
        <p class="data">{{diet.infos.fats}}</p>
      </div>
      <div class="info-box">
        <p class="data-label">{{"PROFILE.NUTRITION.MEAL-PLAN-INFOS.PROTEIN" | translate}}</p>
        <p class="data">{{diet.infos.protein}}</p>
      </div>
    </span>
    <h3>{{"PROFILE.NUTRITION.MEAL-PLAN-INFOS.MEASUREMENTS" | translate}}</h3>
    <div class="info-box">
      <p class="data-label">{{"PROFILE.NUTRITION.MEAL-PLAN-INFOS.ENERGY_REQUIREMENT" | translate}}</p>
      <p class="data">{{diet.infos.energyRequirement}}</p>
    </div>
    <div class="info-box">
      <p class="data-label">{{"PROFILE.NUTRITION.MEAL-PLAN-INFOS.PHYSICAL_ACTIVITY_LEVEL" | translate}}</p>
      <p class="data">{{diet.infos.physicalActivityLevel}}</p>
    </div>
    <div class="info-box">
      <p class="data-label">{{"PROFILE.NUTRITION.MEAL-PLAN-INFOS.MB" | translate}}</p>
      <p class="data">{{diet.infos.mb}}</p>
    </div>
    <div class="info-box meas-tutorial" (click)="openModalMeasurements()">
      <p class="data-label">{{"PROFILE.NUTRITION.MEAL-PLAN-INFOS.MEASUREMENTS" | translate}}</p>
      <p class="data">
        <mat-icon svgIcon="mat:arrow_forward_ios"></mat-icon>
      </p>
    </div>
  </div>
</div>
